/* Client-side pagination + masonry for the review wall (pager ported from
   ShaperCore). Every card is rendered server-side; this decides which page
   shows and deals that page's cards into the shortest of N columns, so one
   tall photo card can't leave a column empty (plain CSS columns can).
   With JS off the pager stays hidden, CSS columns lay out every review. */
(function () {
  if (window.tpReviewPagerReady) return;
  window.tpReviewPagerReady = true;

  function build(grid) {
    var wall = grid.closest('.tp-rw');
    var pager = wall && wall.querySelector('[data-tp-pager]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-tp-review]'));
    var per = parseInt(grid.getAttribute('data-per-page'), 10) || 5;
    if (!pager) return;
    var pages = Math.ceil(cards.length / per);
    var current = 1;

    function columnCount() {
      var w = grid.clientWidth;
      return w >= 880 ? 3 : w >= 560 ? 2 : 1;
    }
    function layout() {
      var n = columnCount();
      grid.classList.add('is-masonry');
      grid.innerHTML = '';
      var cols = [];
      for (var c = 0; c < n; c++) {
        var col = document.createElement('div');
        col.className = 'tp-rw__col';
        grid.appendChild(col);
        cols.push(col);
      }
      cards.forEach(function (card) {
        if (card.hidden) return;
        var shortest = cols.reduce(function (a, b) { return b.offsetHeight < a.offsetHeight ? b : a; });
        shortest.appendChild(card);
      });
    }
    function show(page, scroll) {
      current = Math.min(Math.max(1, page), pages);
      cards.forEach(function (card, i) { card.hidden = Math.floor(i / per) + 1 !== current; });
      layout();
      if (pages < 2) return;
      paint();
      if (scroll) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function button(label, page, opts) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.setAttribute('aria-label', opts.aria || 'Page ' + page);
      if (opts.current) b.setAttribute('aria-current', 'page');
      if (opts.disabled) b.disabled = true;
      b.addEventListener('click', function () { show(page, true); });
      return b;
    }
    function gap() {
      var s = document.createElement('span');
      s.className = 'tp-rw__gap';
      s.textContent = '…';
      return s;
    }
    function paint() {
      pager.innerHTML = '';
      pager.hidden = false;
      pager.appendChild(button('‹', current - 1, { disabled: current === 1, aria: 'Previous page' }));
      // Window the numbers so 10+ pages fit on a phone.
      var end = Math.min(pages, Math.max(1, current - 2) + 4);
      var start = Math.max(1, end - 4);
      if (start > 1) { pager.appendChild(button('1', 1, {})); if (start > 2) pager.appendChild(gap()); }
      for (var p = start; p <= end; p++) pager.appendChild(button(String(p), p, { current: p === current }));
      if (end < pages) { if (end < pages - 1) pager.appendChild(gap()); pager.appendChild(button(String(pages), pages, {})); }
      pager.appendChild(button('›', current + 1, { disabled: current === pages, aria: 'Next page' }));
    }
    var lastCols = 0;
    window.addEventListener('resize', function () {
      if (columnCount() !== lastCols) { lastCols = columnCount(); layout(); }
    });
    // Photos load lazily and change card heights; re-deal once they arrive.
    grid.addEventListener('load', function () { layout(); }, true);
    lastCols = columnCount();
    show(1, false);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tp-reviews]').forEach(function (grid) {
      if (grid.dataset.tpBound) return;
      grid.dataset.tpBound = '1';
      build(grid);
    });
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
